module.exports = __webpack_public_path__ + "static/media/proPicPlaceholder.bfd04dbe.svg";